// extracted by mini-css-extract-plugin
export default {"wrapper":"A_CopyLinkButton_wrapper__bNTnA"};